const PREFIX = '[SIDE MENU]';

export const SET_MENU_STATE = `${PREFIX} SET_MENU_STATE`;

export const setMenuState = isOpen => ({
  type: SET_MENU_STATE,
  isOpen,
});

export const openMenu = () => (dispatch) => {
  dispatch(setMenuState(true));

  document
    .getElementsByTagName('body')[0]
    .style.overflow = 'hidden';
};

export const closeMenu = () => (dispatch) => {
  dispatch(setMenuState(false));

  document
    .getElementsByTagName('body')[0]
    .style.overflow = 'visible';
};



// WEBPACK FOOTER //
// ./src/store/actions/sideMenu.js